module.exports = __webpack_public_path__ + "img/T2A_rc_1.17339433.png";